import { ImageFragment, LinkFragment } from '@/lib/fragments'

import { graphql } from '@/lib/query'

const SectionImageTextFragment = graphql(
  /* GraphQL */ `
    fragment SectionImageTextFragment on SectionImageTextRecord @_unmask {
      id
      _modelApiKey
      __typename
      image {
        ...ImageFragment
      }
      numbers {
        number
        description
      }
      text
      link {
        ...LinkFragment
      }
    }
  `,
  [ImageFragment, LinkFragment]
)

export default SectionImageTextFragment
